'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

exports.createResource = createResource;

var _utils = require('../utils');

var _entityHasSameId = require('./entityHasSameId');

var _fields = require('./fields');

var _makeActions = require('./makeActions');

var _makeDataSelectors = require('./makeDataSelectors');

var _makeReducer = require('./makeReducer');

var _makeSaga = require('./makeSaga');

var _makeSelectors = require('./makeSelectors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createResource(name, options) {
    if (!name) {
        throw new Error('resource requires a name');
    }
    if (!options) {
        throw new Error('resource requires options');
    }
    options = (0, _extends4.default)({
        id: 'id'
    }, options);
    let descriptor = {
        actions: (0, _makeActions.makeActions)(name),
        data: (0, _makeDataSelectors.makeDataSelectors)(options),
        fields: _fields.selectors,
        hasSameId: (0, _entityHasSameId.entityHasSameId)(options),
        name: name,
        options: options,
        selectors: (0, _makeSelectors.makeSelectors)(name, options, (0, _entityHasSameId.entityHasSameId)(options))
    };

    for (var _len = arguments.length, middlewares = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        middlewares[_key - 2] = arguments[_key];
    }

    return (0, _extends4.default)({}, descriptor, {
        create: props => (0, _extends4.default)({}, (0, _fields.stripFields)(props), (0, _defineProperty3.default)({}, _fields.fields.tempId, (0, _utils.makeTempKey)())),
        hasSameId: descriptor.hasSameId,
        reducer: (0, _makeReducer.makeReducer)(descriptor),
        saga: (0, _makeSaga.makeSaga)(descriptor, ...middlewares.map(f => f(descriptor)))
    });
}
//# sourceMappingURL=createResource.js.map


// WEBPACK FOOTER //
// ./node_modules/redux-saga-resources/node/resource/createResource.js